module.exports = __webpack_public_path__ + "img/delete.67424347.svg";